import React, { PropTypes } from 'react';

import { container } from './styles.module.css';

/**
 * Container presentational component.
 */
const Container = ({ className, children }) => (
  <div className={[container, className].join(' ')}>{children}</div>
);

Container.propTypes = {
  /**
   * Children contents of container.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
};

Container.defaultProps = {
  children: null,
  className: '',
};

export default Container;



// WEBPACK FOOTER //
// ./app/src/components/Container/index.jsx